import { API_BASE_URL } from '../config';
import { UserData } from '../context/User/useUser';
import createHttpClient from './HttpClient';

function createUserService(baseURL: string) {
  const httpClient = createHttpClient(baseURL);

  return {
    getUser: async (): Promise<UserData> => {
      return httpClient.get(`/user`);
    },
    getUsers: async (
      queryParams?: string
    ): Promise<{ users: UserData[]; totalCount: number }> => {
      const params =
        queryParams ||
        new URLSearchParams({ page: '1', limit: '100' }).toString();
      return httpClient.get(`/admin/users?${params}`);
    },
    signIn: async (email: string): Promise<{ message: string }> => {
      return httpClient.post('/sign-in', { email });
    },
    verifyAuth: async (magicToken: string): Promise<void> => {
      return httpClient.post(`/verify-auth`, {
        magicToken,
      });
    },
    signOut: async (): Promise<void> => {
      return httpClient.delete('/sign-out');
    },
    signUp: async (
      email: string,
      name: string,
      isAcceptingMarketing: boolean
    ): Promise<{ message: string }> => {
      return httpClient.post('/sign-up', {
        email,
        name,
        isAcceptingMarketing,
      });
    },
    deleteUser: async (userId: number): Promise<{ message: string }> => {
      return httpClient.delete(`/admin/users/${userId}`);
    },
    deleteSelf: async (): Promise<{ message: string }> => {
      return httpClient.delete(`/user`);
    },
    updateMarketingConsent: async (
      isAcceptingMarketing: boolean
    ): Promise<{ message: string }> => {
      return httpClient.post(`/user/marketing-consent`, {
        isAcceptingMarketing,
      });
    },
    updateLocale: async (locale: string): Promise<{ message: string }> => {
      return httpClient.put(`/user/locale`, { locale });
    },
  };
}

export const userService = createUserService(API_BASE_URL);
